const initialState = {
  data: undefined,
  errorMessage: null,
  isLoading: false,
  isFulfilled: false,
  isRejected: false,
};

export const GetListScheduleData = (state = initialState, action) => {
  switch (action.type) {
    case "GET_LIST_SCHEDULE_PENDING":
      return {
        ...state,
        isLoading: true,
        isRejected: false,
        isFulfilled: false,
      };
    case "GET_LIST_SCHEDULE_REJECTED":
      return {
        ...state,
        isLoading: false,
        isRejected: true,
        // errorMessage: action.payload.response.data ?? null,
      };
    case "GET_LIST_SCHEDULE_FULFILLED":
      return {
        ...state,
        isLoading: false,
        isFulfilled: true,
        data: action.payload.response.data?.result ?? [],
      };
    default:
      return state;
  }
};
